module.exports = __webpack_public_path__ + "img/p1-info.fbe3eb7e.jpg";